import React, { useEffect, useState } from 'react';
import { useHistory, withRouter } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Seccion from "../componentes/Seccion";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Header from "../componentes/Header";
import Footer from '../componentes/Footer';
import AboutCirc from '../componentes/AboutCirc';
import Testimonials from '../componentes/Testimonials';


function Usuarios() {

    return (
        <div>
            <Header></Header>
            <div className="base-page">
                <div>
                    <Seccion theme='white' epicBarDirection="right" id="users-features">
                        <Row className="user-cont" style={{paddingLeft:"40px"}}>
                            <Col md={12} lg={12} xl={6}>
                                <div>
                                    <h2 className="title mrg-bt-10 line-height-title letter-spacing-3px mrg-right-60 fw-black fs-60 titleStart">
                                        <span className="fw-light">
                                            WHY<br/>
                                            USE
                                        </span><br/>
                                        DICIO?
                                    </h2>
                                
                                    <p className="fw-bold fs-26">
                                        What do you get when you download DICIO?
                                    </p>
                                
                                    <ul className="--check">
                                        <li>100% control of your information.</li>
                                        <li>All data is hack-proof encrypted.</li>
                                        <li>You get incentives to use.</li>
                                        <li>Always updated file.</li>
                                        <li>Zero passwords.</li>
                                        <li>We consolidate and maintain your credentials.</li>
                                    </ul>
                                </div>
                            </Col>
                            <Col md={12} lg={12} xl={6} className="padSec video users-video">
                                <div className="aspect-ratio-16:9">
                                    <iframe 
                                    width="727" 
                                    height="409" 
                                    src="https://www.youtube.com/embed/GYu2Ui2A8vY" 
                                    frameborder="0" 
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                                    allowfullscreen
                                    className="w-100 aspect-ratio-item"
                                    style={{height: "287px"}}>
                                    </iframe>
                                </div>
                            </Col>
                        </Row>
                        
                    </Seccion>

                    <Seccion theme='dark' id="users-about">
                        <div className="aboutContainer" style={{paddingLeft:"40px"}}>
                            <Row>
                                <Col md={12}>
                                    <AboutCirc></AboutCirc>
                                </Col>
                                
                            </Row>
                        </div>

                    </Seccion>

                    <Seccion theme='white'  id="users-testimonial">
                        
                            <Row>
                                <Col md={12}>
                                    <Testimonials></Testimonials>
                                </Col>
                            </Row>
                        
                    </Seccion>

                    <Seccion theme='dark' id="users-appContainer">

                        <Row className="parallax" style={{position:"relative"}}>

                            <Col lg={12} className="parallax-content" style={{position: "relative",}}>
                                <Row className=" padSec scontainer padSecNull" style={{paddingLeft:"90px"}}>
                                    <Col className="padNull" md={6} style={{paddingTop:"150px"}}>
                                        <h2 className="title titleStart c-white middle mrg-bt-10 line-height-title letter-spacing-3px mrg-right-60 fw-black fs-60" >
                                            <span className="fw-light">
                                                COOMING <br/>
                                                SOON
                                            </span> &nbsp;
                                            IOS / 
                                            <br/>
                                            ANDROID
                                        </h2>
                                    </Col>
                                    
                                    <Col md={6} style={{padding:"20px"}}>
                                        <img src="./img/app-808.svg" alt="" style={{maxWidth: "600px", width: "100%"}}/>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Seccion>
                </div>
            </div>
            <Footer></Footer>
        </div>
    )
}

export default (Usuarios)